import { formatDate, formatCurrencyWhole } from '../../../utils/formatters';
import '../../../styles/AmiCell.scss';

const AmiCell = ({
  effectiveDate,
  currentValue,
  upcomingValue,
  upcomingEffectiveDate,
  onClick,
  editPayload
}) => {
  return (
    <td
      className="text-center align-middle ami-edit-cell"
      title={`Effective since: ${formatDate(effectiveDate)}`}
    >
      <button
        type="button"
        className="ami-cell-button"
        onClick={() => onClick(editPayload)}
        title="Edit AMI"
      >
        <div>
          <strong>{formatCurrencyWhole(currentValue)}</strong>
        </div>

        {upcomingValue && (
          <div className="text-success">
            <strong
              title={`Becomes effective: ${formatDate(
                upcomingEffectiveDate
              )}`}
            >
              {formatCurrencyWhole(upcomingValue)}
            </strong>
          </div>
        )}

        <div className="ami-pencil" aria-hidden>✎</div>
      </button>
    </td>
  );
};

export default AmiCell;